import Vue from 'vue';



export default function deepSetValue(state, keyMap, value, prefix = '') {
  const tmp = keyMap.split('.');
  if (tmp.length === 1) {
    if (value === undefined) {
      $ls.deleteKey(prefix + keyMap);
      Vue.delete(state, keyMap);
    } else {
      $ls.set(prefix + keyMap, value);
      Vue.set(state, keyMap, value);
    }
    return;
  }

  const topKey = tmp[0];
  let currentKey = topKey;
  let data, topData, parent = null, _key = null;

  const check = () => {
    if (data === undefined || data === '___dn-ls-undefined___') {
      if (parent === null) {
        Vue.set(state, topKey, {});
        parent = state[topKey];
        data = parent;
      } else {
        Vue.set(parent, _key, {});
        data = parent[_key];
      }
    } else if (data === null || typeof data !== 'object') {
      throw new Error('ローカルストレージ「' + currentKey + '」にはオブジェクトに解決できない値が入っているためデータをコミットできません。');
    }
  }

  data = state[topKey];
  data = data === undefined ? '___dn-ls-undefined___' : data;
  check();

  topData = data;

  for (let i = 1, l = tmp.length - 1; i < l; i++) {
    _key = tmp[i];
    parent = data;
    data = data[_key];
    currentKey += '.' + tmp[i];
    check();
  }

  Vue.set(data, tmp[tmp.length - 1], value);
  $ls.set(prefix + topKey, state[topKey]);
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ls/util/deepSetState.js